import { render, staticRenderFns } from "./Oma.vue?vue&type=template&id=96989fa6&"
import script from "./Oma.vue?vue&type=script&lang=js&"
export * from "./Oma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Oma.vue"
export default component.exports